{
  "en": {
    "documents": {
      "name_required": "Document name is required",
      "name_too_long": "Document name must not exceed 255 characters",
      "phase_required": "Phase is required",
      "type_required": "Type is required",
      "date_required": "Reception date is required",
      "invalid_date": "Invalid date format",
      "reference_too_long": "Reference must not exceed 100 characters",
      "version_too_long": "Version must not exceed 50 characters",
      "sender_too_long": "Sender must not exceed 200 characters"
    }
  },
  "fr": {
    "documents": {
      "name_required": "Le nom du document est requis",
      "name_too_long": "Le nom du document ne doit pas dépasser 255 caractères",
      "phase_required": "La phase est requise",
      "type_required": "Le type est requis",
      "date_required": "La date de réception est requise",
      "invalid_date": "Format de date invalide",
      "reference_too_long": "La référence ne doit pas dépasser 100 caractères",
      "version_too_long": "La version ne doit pas dépasser 50 caractères",
      "sender_too_long": "L'émetteur ne doit pas dépasser 200 caractères"
    }
  },
  "nl": {
    "documents": {
      "name_required": "Documentnaam is verplicht",
      "name_too_long": "Documentnaam mag niet langer zijn dan 255 tekens",
      "phase_required": "Fase is verplicht",
      "type_required": "Type is verplicht",
      "date_required": "Ontvangstdatum is verplicht",
      "invalid_date": "Ongeldig datumformaat",
      "reference_too_long": "Referentie mag niet langer zijn dan 100 tekens",
      "version_too_long": "Versie mag niet langer zijn dan 50 tekens",
      "sender_too_long": "Afzender mag niet langer zijn dan 200 tekens"
    }
  }
}
